module.exports = require('./configureStoreProd').default